import {
  type TeamCalendarState,
  isTeamSelected,
} from "@/features/calendar/calendarFilter/appointmentFilterReducer";
import type { CoWorkerCalendar } from "@/features/calendar/team-calendar/types";
import { isCoworkerAvailable } from "@/features/calendar/utils/utils";
import { type Settings } from "@repo/ui";

export const filterTeamCoworkers = ({
  coworkers,
  teamCalendarFilter,
  calendarSettings,
}: {
  coworkers: CoWorkerCalendar[];
  teamCalendarFilter: TeamCalendarState;
  calendarSettings: Settings["calendar"];
}): {
  availableCw: CoWorkerCalendar[];
  unAvailableCw: CoWorkerCalendar[];
} => {
  const isDeselected = (emailId: string) =>
    isTeamSelected(teamCalendarFilter) &&
    teamCalendarFilter.selection.deselectedMemberIds.includes(emailId);

  const filterSelectedCoworkers = coworkers.filter(
    (coworker) => !isDeselected(coworker.emailId)
  );

  const availableCw = filterSelectedCoworkers.filter((coworker) =>
    isCoworkerAvailable(
      coworker,
      calendarSettings?.absence_overrides_availability,
      calendarSettings?.hide_absence_blocks
    )
  );

  const unAvailableCw = filterSelectedCoworkers.filter(
    (cw) =>
      !isCoworkerAvailable(
        cw,
        calendarSettings?.absence_overrides_availability,
        calendarSettings?.hide_absence_blocks
      )
  );

  return {
    availableCw: availableCw,
    unAvailableCw: unAvailableCw,
  };
};
